import { useTranslation } from "react-i18next";
import HtmlRenderer from "../../../../components/render-html/RenderHtml";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { renderDate } from "../../../../utils/app.utils";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";



type profileDetailProps = {
    personal_detail: {
        full_name: string;
        nick_name: string;
        id_card: string;
        tel: string;
        personal_email: string;
        organization_email: string;
        gender: string;
        age: string;
        ethnicity: string;
        nationality: string;
        religion: string;
    },
    work_detail: {
        current_position_name: string;
        level: string;
        organization_tel: string;
    }

}
export const ProfileDetail: React.FC<profileDetailProps> = ({ personal_detail, work_detail }) => {
    const { t } = useTranslation();
    return (
        <Box>
            <Typography my={2} variant="h6">
                {t("HOME_PAGE_PERSONAL_INFORMATION")}
            </Typography>

            <Box className="flex flex-col gap-3">
                <Typography>
                    {t("HOME_PAGE_NAME_-_SURNAME")} : {personal_detail.full_name || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_NICKNAME/ALIAS")} : {personal_detail.nick_name || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_OFFICER_IDENTIFICATION_NUMBER")} : {personal_detail.id_card || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_PHONE_NUMBER")} : {personal_detail.tel || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_PERSONAL_EMAIL")} : {personal_detail.personal_email || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_CORPORATE_EMAIL")} : {personal_detail.organization_email || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_SEX")} : {personal_detail.gender || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_AGE_(YEARS)")}  : {personal_detail.age || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_ETHNICITY")} : {personal_detail.ethnicity || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_NATIONALITY")} : {personal_detail.nationality || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_RELIGION")} : {personal_detail.religion || "-"}
                </Typography>
            </Box>

            <Typography my={2} variant="h6">
                {t("HOME_PAGE_JOB_POSITION_INFORMATION")}
            </Typography>
            <Box className="flex flex-col gap-3">
                <Typography>
                    {t("HOME_PAGE_CURRENT_JOB_POSITION")} : {work_detail.current_position_name || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_LEVEL")} : {work_detail.level || "-"}
                </Typography>
                <Typography>
                    {t("HOME_PAGE_WORK_PHONE_NUMBER")} : {work_detail.organization_tel || "-"}
                </Typography>
            </Box>
        </Box>
    )
}

type educationDetailProps = {
    data: any[];
}
export const EducationDetail: React.FC<educationDetailProps> = ({ data }) => {
    const { t } = useTranslation();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCell = [
        {
            id: "faq_seq", width: 120, sortable: false, disablePadding: false, align: 'center', label: t("HOME_PAGE_EDUCATION_LEVEL")
        },
        {
            id: "2", disablePadding: false, width: 150, sortable: false, align: "left", label: t("HOME_PAGE_EDUCATIONAL_QUALIFICATIONS")
        },
        {
            id: "5", disablePadding: false, width: 100, sortable: false, align: "left", label: t("HOME_PAGE_GROUP")
        },
        {
            id: "6", disablePadding: false, width: 110, sortable: false, align: "center", label: t("HOME_PAGE_MAJOR")
        },
        {
            id: "7", disablePadding: false, width: 110, sortable: false, align: "center", label: t("HOME_PAGE_EDUCATIONAL_INSTITUTIONS")
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            certificate,
            educational_institutions,
            faculty,
            major,
            education_type,
        } =
            objData;

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: education_type?.education_type_name || "-" },

                {
                    option: "TEXT",
                    align: "left",
                    label: certificate || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: faculty || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: major || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: educational_institutions || "-"
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    return (
        <Box className="w-full">
            <TableCustom
                tableMinWidth={1440}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCell}
                rowCount={data?.length}
                rowsData={data?.slice(
                    (page - 1) * pageLimit,
                    ((page - 1) * pageLimit) + pageLimit
                ).map((data: any, i: any) => {
                    return renderData(data, i)
                })}
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
            />
        </Box>
    )
}

type workExperienceProps = {
    data: any[];
}
export const WorkExperienceDetail: React.FC<workExperienceProps> = ({ data }) => {
    const { t } = useTranslation();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCell = [
        {
            id: "1", width: 120, sortable: false, disablePadding: false, align: 'center', label: t("HOME_PAGE_NAME_OF_ESTABLISHMENT")
        },
        {
            id: "2", disablePadding: false, width: 150, sortable: false, align: "left", label: t("HOME_PAGE_PHONE_NUMBER")
        },
        {
            id: "5", disablePadding: false, width: 100, sortable: false, align: "left", label: t("HOME_PAGE_START_DATE")
        },
        {
            id: "6", disablePadding: false, width: 110, sortable: false, align: "center", label: t("HOME_PAGE_END_DATE")
        },
        {
            id: "7", disablePadding: false, width: 110, sortable: false, align: "center", label: t("HOME_PAGE_NUMBER_OF_MONTHS_WORKED")
        },
        {
            id: "8", disablePadding: false, width: 110, sortable: false, align: "center", label: t("HOME_PAGE_STARTING_JOB_POSITION")
        },
        {
            id: "9", disablePadding: false, width: 110, sortable: false, align: "center", label: t("HOME_PAGE_JOB_POSITION_ENDED")
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            company,
            work_contact,
            date_end_work,
            date_start_work,
            position_start,
            position_end
        } =
            objData;

        const month_count = (date_end_work && date_start_work) ? moment(date_end_work).diff(date_start_work, 'months') : ""
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: company || "-" },

                {
                    option: "TEXT",
                    align: "left",
                    label: work_contact || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: date_start_work ? renderDate(date_start_work) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: date_end_work ? renderDate(date_end_work) : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: month_count || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: position_start || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: position_end || "-"
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    return (
        <Box className="w-full">
            <TableCustom
                tableMinWidth={1440}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCell}
                rowCount={data?.length}
                rowsData={data?.slice(
                    (page - 1) * pageLimit,
                    ((page - 1) * pageLimit) + pageLimit
                ).map((data: any, i: any) => {
                    return renderData(data, i)
                })}
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
            />
        </Box>
    )
}


type academicAndResearchProps = {
    hidden_step?: boolean;
    article?: {
        title: string;
        detail: string;
        link?: string;
        department?: string;
    }[],
    academic?: {
        title: string;
        detail: string;
        link?: string;
    }[],
    enable_department?: boolean;

    // text_html: string;
}
export const AcademicAndResearch: React.FC<academicAndResearchProps> = ({ academic, article, hidden_step, enable_department }) => {
    const { t } = useTranslation();

    const [step, setStep] = useState<number>(0);
    const [step_data, set_step_data] = useState<{ step: number, type: string, name: string }[]>([
        {
            step: 0,
            name: "งานวิจัย", // i18n-ignore (translated at render: t(list.name))
            type: "article"
        },
        {
            step: 1,
            name: "บทความ", // i18n-ignore (translated at render: t(list.name))
            type: "academic"
        },
        {
            step: 2,
            name: "ทั้งหมด", // i18n-ignore (translated at render: t(list.name))
            type: "all"
        },
    ])
    return (
        <Box>
            <Box className="flex justify-end gap-4 items-center">
                {!hidden_step && (
                    <>
                        {step_data.map((list, i) => {
                            return (
                                <React.Fragment key={i}>
                                    <Typography onClick={() => setStep(list.step)} className="cursor-pointer" sx={{
                                        color: list.step === step ? "black" : "rgba(0,0,0,0.12)"
                                    }}>
                                        {t(list.name)}
                                    </Typography>
                                    {[0, 1].includes(i) && (
                                        <Typography sx={{ color: "#f4f4f4" }}>
                                            |
                                        </Typography>
                                    )}
                                </React.Fragment>
                            )
                        })}
                    </>
                )}
            </Box>
            <Box>
                {[0, 2].includes(step) && (
                    <>
                        {article?.map((list, index) => {
                            return (
                                <Box key={`_${index}`}>
                                    <Typography variant="h5">
                                        {list?.title || "-"}
                                    </Typography>
                                    {enable_department && (
                                        <HtmlRenderer
                                            html={list?.detail || ""}
                                        />
                                    )}
                                    {!enable_department && (
                                        <>
                                            <Typography variant="subtitle2">
                                                {t("ประเภท : งานวิจัย")}
                                            </Typography>
                                        </>
                                    )}
                                    {enable_department && (
                                        <Typography>
                                            {t("หน่วยงานที่มอบ :")} {list?.department || ""}
                                        </Typography>
                                    )}
                                    {!enable_department && (
                                        <HtmlRenderer
                                            html={list?.detail || ""}
                                        />
                                    )}
                                    {list?.link && (
                                        <Typography>
                                            {t("ลิงค์ :")} {list?.link || ""}
                                        </Typography>
                                    )}
                                </Box>
                            )
                        })}
                    </>
                )}
                {[1, 2].includes(step) && (
                    <>
                        {academic?.map((list, index) => {
                            return (
                                <Box key={`_${index}`}>
                                    <Typography variant="h5">
                                        {list?.title || "-"}
                                    </Typography>
                                    <Typography variant="subtitle2">
                                        {t("ประเภท : บทความ")}
                                    </Typography>
                                    {/* <Typography>
                                        {list?.detail || "-"}
                                    </Typography> */}
                                    <HtmlRenderer
                                        html={list?.detail || ""}
                                    />
                                    {
                                        list?.link && (
                                            <Typography>
                                                {t("ลิงค์ :")} {list?.link || ""}
                                            </Typography>
                                        )
                                    }
                                </Box>
                            )
                        })}
                    </>
                )}
            </Box >
        </Box >
    )
}